export default {
  install(Vue, options) {
    /**
     * 只在生产环境使用
     */
    if (process.env.NODE_ENV === 'production') {
      /**
       * 百度统计分析脚本
       */
      var _hmt = _hmt || [];
      (() => {
        var hm = document.createElement('script');
        hm.src = `//hm.baidu.com/hm.js?${options.id}`;
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(hm, s);
      })();
    }
  },
};
